/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.blockModule')

  .directive('bulbBlock', bulbBlock);

function bulbBlock() {
  return {
    restrict: 'E',
    scope: {
      unit: '=',
      groupId: '=?',
      pinnedUnitIds: '=?',
      authorImpliedByContext: '=?',
      typeImpliedByContext: '=?',
      tile: '@',
    },
    template: '<div ng-include="blockCtrl.getTemplateUrl()"></div>',
    controller: 'BlockController as blockCtrl',
    bindToController: true,
    link(scope, element, attrs, blockCtrl) {

      if (attrs.authorImpliedByContext === '') {
        // Interpret a present but valueless author-implied-by-context attribute as true
        blockCtrl.authorImpliedByContext = true;
      }
      if (attrs.typeImpliedByContext === '') {
        // Interpret a present but valueless type-implied-by-context attribute as true
        blockCtrl.typeImpliedByContext = true;
      }

      blockCtrl.isTile = attrs.tile;
      blockCtrl.presentation = attrs.presentation;

      blockCtrl.init();

      // Collections with images need the <footer> to appear after the image
      // FUTURE: Sure would be nice to have a more elegant way of doing this
      if (blockCtrl.blockType === 'collection'
        && (blockCtrl.unit.hasOwnProperty('coverImage') || blockCtrl.unit.hasOwnProperty('horizontalImageUrl'))) {
        element.find('footer').appendTo(element.find('.bulb-block'));
      }

      /**
       * Determine if the coverImage is 'wide' or 'tall' based on the aspect ratio of the image and the containing
       * figure element, and set the appropriate class so it is correctly centered vertically or horizontally.
       */
      function updateCoverImage() {
        const { coverImage } = blockCtrl.unit;
        if (coverImage) {
          const figure = jQuery('.bulb-block-cover-image', element);
          if (coverImage.width / coverImage.height > figure.width() / figure.height()) {
            // center coverImage horizontally
            blockCtrl.coverImageAspect = 'wide';
          } else {
            // center coverImage vertically
            blockCtrl.coverImageAspect = 'tall';
          }
        } else {
          blockCtrl.coverImageAspect = null;
        }
      }

      if (blockCtrl.blockType === 'collection') {
        // When coverImage appears (ng-if) or changes, or when the containing figure changes width, update the
        // image so it is correctly centered vertically or horizontally.
        scope.$watch('blockCtrl.unit.coverImage', updateCoverImage);
        scope.$watch(() => jQuery('.bulb-block-cover-image', element).width(), updateCoverImage);
      }
    },
  };
}
